/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_polygon_account_description = /** @type {(inputs: {}) => string} */ () => {
	return `Recibe depósitos cripto en la red Polygon con comisiones bajas y transacciones rápidas`
};

const en_accounts_polygon_account_description = /** @type {(inputs: {}) => string} */ () => {
	return `Receive crypto deposits on the Polygon network with low fees and fast transactions`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_polygon_account_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_polygon_account_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_polygon_account_description", locale)
	if (locale === "es") return es_accounts_polygon_account_description(inputs)
	return en_accounts_polygon_account_description(inputs)
};
export { accounts_polygon_account_description as "accounts.polygon.account_description" }